import React, { useState } from 'react';
import API from '../services/api';

const CONFIRM_WORD = 'SUPPRIMER';

// Suppression du compte par l'utilisateur : confirmation en deux temps, puis appel au serveur
// qui résilie l'abonnement, efface les données et supprime le compte.
export default function DeleteAccount({ onDeleted, subscribed, initiallyOpen = false, onCancel }) {
  const [open, setOpen] = useState(initiallyOpen);
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const confirmed = typed.trim().toUpperCase() === CONFIRM_WORD;

  const submit = async () => {
    if (!confirmed || busy) return;
    setBusy(true);
    setError('');
    try {
      await API.post('/account/delete', { confirm: true });
      onDeleted();
    } catch (e) {
      setError(e.response?.data?.detail || 'La suppression n\'a pas pu aboutir. Réessayez dans un instant.');
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} style={s.link}>Supprimer mon compte</button>
    );
  }

  return (
    <div style={s.box} role="region" aria-label="Supprimer mon compte">
      <p style={s.title}>Supprimer mon compte</p>
      <p style={s.text}>
        Votre compte et toutes vos données seront effacés définitivement : profil, consommation, historique
        {subscribed ? ', et votre abonnement sera résilié immédiatement' : ''}. Cette action ne peut pas être annulée.
      </p>
      <label htmlFor="del-confirm" style={s.text}>Pour confirmer, tapez <strong>{CONFIRM_WORD}</strong> :</label>
      <input id="del-confirm" value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" style={s.input} />
      {error && <p style={s.error} role="alert">{error}</p>}
      <div style={s.row}>
        <button onClick={() => { setOpen(false); setTyped(''); setError(''); if (onCancel) onCancel(); }} disabled={busy} style={s.cancel}>Annuler</button>
        <button onClick={submit} disabled={!confirmed || busy} style={{ ...s.danger, opacity: confirmed && !busy ? 1 : 0.45, cursor: confirmed && !busy ? 'pointer' : 'not-allowed' }}>
          {busy ? 'Suppression…' : 'Supprimer définitivement'}
        </button>
      </div>
    </div>
  );
}

const s = {
  link: { background: 'none', border: 'none', color: 'rgba(238,242,255,0.38)', fontSize: '0.78rem', textDecoration: 'underline', cursor: 'pointer', padding: '14px 0 0', display: 'block', fontFamily: "'Plus Jakarta Sans', sans-serif" },
  box: { marginTop: 16, border: '1px solid rgba(255,68,68,0.3)', borderRadius: 12, padding: 16, background: 'rgba(255,68,68,0.04)', display: 'flex', flexDirection: 'column', gap: 10, fontFamily: "'Plus Jakarta Sans', sans-serif" },
  title: { margin: 0, fontWeight: 700, color: '#ff6b6b', fontSize: '0.9rem', fontFamily: "'Lexend', sans-serif" },
  text: { margin: 0, color: 'rgba(238,242,255,0.7)', fontSize: '0.8rem', lineHeight: 1.5 },
  input: { background: 'rgba(238,242,255,0.04)', border: '1px solid rgba(238,242,255,0.15)', borderRadius: 8, padding: '10px 12px', color: '#EEF2FF', fontSize: '0.9rem', fontFamily: 'inherit' },
  error: { margin: 0, color: '#ff6b6b', fontSize: '0.78rem' },
  row: { display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' },
  cancel: { background: 'none', border: '1px solid rgba(238,242,255,0.15)', color: 'rgba(238,242,255,0.7)', borderRadius: 8, padding: '9px 14px', fontSize: '0.8rem', cursor: 'pointer', fontFamily: 'inherit' },
  danger: { background: '#ff4444', border: 'none', color: '#fff', borderRadius: 8, padding: '9px 14px', fontSize: '0.8rem', fontWeight: 700, fontFamily: 'inherit' },
};
